import { useEffect, useState } from 'react';
import CommentIcon from '../../../assets/Feed/CommentIcon';
import LikeIcon from '../../../assets/Feed/LikeIcon';
import ShareIcon from '../../../assets/Posts/ShareIcon';
import { api } from '../../../services/api';
import { numberFormatter } from '../../../utils/formatter';
import ShareModal from '../../Modals/SharePostModal';
import User from '../../User';
import {
  ButtonItem,
  ButtonsContainer,
  Container,
  Description,
  DescriptionSection,
} from './styles';

type PostInformationProps = {
  id: string;
  selectedImage: number;
  authorUsername: string;
  avatar: string;
  timeSince: string;
  descriptions: string[];
  likes: number;
  numberOfComments: number;
  openModal: () => void;
  liked: boolean;
  setLiked: (liked: boolean) => void;
  likesCount: number;
  setLikesCount: (likes: number) => void;
  commentsCount: number;
  setCommentsCount: (comments: number) => void;
};

export default function PostInformation({
  selectedImage,
  id,
  authorUsername,
  avatar,
  timeSince,
  descriptions,
  openModal,
  liked,
  setLiked,
  likesCount,
  setLikesCount,
  commentsCount,
  setCommentsCount,
}: PostInformationProps) {
  const [shortDescription, setShortDescription] = useState<string>((descriptions && descriptions.length > 0) ? descriptions[selectedImage].slice(0, 97) : ' ');
  const [showMore, setShowMore] = useState(false);
  const [shareModal, setShareModal] = useState(false);

  useEffect(() => {
    if (showMore && descriptions && descriptions.length > 0) {
      setShortDescription(descriptions[selectedImage]);
    }
    else {
      if (descriptions && descriptions[selectedImage] && descriptions[selectedImage].length > 0) {
        setShortDescription(descriptions[selectedImage].slice(0, 97));
      } else {
        setShortDescription(' ')
      }
    }
  }, [showMore, selectedImage]);

  const handleLike = async () => {
    setLiked(!liked);
    if (!liked) {
      setLikesCount(likesCount + 1)
    } else {
      setLikesCount(likesCount - 1)
    }
    try {
      const response = await api.post(`/like/${id}`)
      if (response.status !== 200 && !liked) {
        setLiked(!liked)
        setLikesCount(likesCount - 1)
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <>
      {shareModal && <ShareModal id={id} authorUsername={authorUsername} open={shareModal} onClose={setShareModal} />}
      <Container>
        <User icon={avatar} username={authorUsername} timeSince={timeSince} follow={true} />
        <DescriptionSection>
          <Description>
            {shortDescription}
            {descriptions && descriptions[selectedImage] && descriptions[selectedImage].length > 97 &&
              <strong
                style={{ fontSize: '12px', color: 'rgba(27, 27, 27, 1)', fontFamily: 'Inter-Bold', cursor: 'pointer' }}
                onClick={openModal}>
                {showMore ? ' ...menos' : ' ...mais'}
              </strong>
            }
          </Description>
        </DescriptionSection>
        <ButtonsContainer>
          <ButtonItem onClick={handleLike}>
            <LikeIcon liked={liked} />
            {numberFormatter(likesCount)}
          </ButtonItem>
          <ButtonItem onClick={openModal}>
            <CommentIcon />
            {numberFormatter(commentsCount)}
          </ButtonItem>
          <ButtonItem onClick={() => setShareModal(true)}>
            <ShareIcon />
          </ButtonItem>
        </ButtonsContainer>
      </Container>
    </>
  );
}